import './DefaultPage.css'
import React from 'react'
import Helmet from 'react-helmet'

import Content from '../components/Content'

export const DefaultPageTemplate = ({
    title,
    subtitle,
    defaultContentSection
}) => {
  return <main className="DefaultPage">
    <Helmet>
      <title>Assetlogue – {title}</title>
    </Helmet>
    <div className='container'>
        <div className='default-header'>
            {title && <h1>{title}</h1>}
            {subtitle && <p className='subtitle'>{subtitle}</p>}
        </div>
        {defaultContentSection && defaultContentSection.map(({ content }) =>
            <div className='default-content'>
                <Content src={content} />
            </div>
        )}
    </div>
  </main>
}

const DefaultPage = ({ data: { page } }) => (
  <DefaultPageTemplate {...page.frontmatter} body={page.html} />
)
export default DefaultPage

export const pageQuery = graphql`
  query DefaultPage($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        subtitle
        defaultContentSection {
            content
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/DefaultPage.js